import { render, staticRenderFns } from "./RelatorioEditorListaSelecao.vue?vue&type=template&id=be67e538&"
import script from "./RelatorioEditorListaSelecao.vue?vue&type=script&lang=js&"
export * from "./RelatorioEditorListaSelecao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports